import {
  Button,
  ListGroup,
  Modal,
  Overlay,
  Text,
} from '@cubeyou-team/hx-react-components';
import React, { FC } from 'react';

import translations from 'src/lang';

const lang = 'en-US';
const translation = translations[lang].MODALS.CONFIRM_DATA_SOURCE_CHANGE_MODAL;

interface ConfirmDataSourceChangeModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDataSourceChangeModal: FC<ConfirmDataSourceChangeModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  return (
    <Overlay isOpen={isOpen}>
      <Modal
        handleClose={onCancel}
        footer={
          <ListGroup
            direction="row"
            items={[
              <Button key="0" size="small" onClick={onConfirm}>
                {translation.BUTTON_CONTINUE}
              </Button>,
              <Button
                key="1"
                size="small"
                variant="outlined"
                onClick={onCancel}
              >
                {translation.BUTTON_STAY_HERE}
              </Button>,
            ]}
          />
        }
        onFormSubmit={onConfirm}
        title={translations[lang].MODALS.CONFIRM_DATA_SOURCE_CHANGE_MODAL.TITLE}
      >
        <div className="flex flex-col">
          {translation.CONTENT.split('\n').map((line, index) => (
            <Text key={index} size="body" variant="dark">
              {line.trim()}
            </Text>
          ))}
        </div>
      </Modal>
    </Overlay>
  );
};
